module.exports = __webpack_public_path__ + "img/icon-news-gray.130fcdff.svg";